var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgJobUpdatesi = function SvgJobUpdatesi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: props.color || 'currentColor',
    transform: "translate(4 4)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M9 11h6v4H9z",
    "data-name": "Path 4047"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.4 10H14V8.8a.86.86 0 0 0-.8-.8h-2.4a.86.86 0 0 0-.8.8V10H8.6a.645.645 0 0 0-.6.6v4.8a.645.645 0 0 0 .6.6h6.8a.645.645 0 0 0 .6-.6v-4.8a.645.645 0 0 0-.6-.6M11 9h2v1h-2zm4 6H9v-4h6z",
    "data-name": "Path 4048"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgJobUpdatesi);
export default ForwardRef;